import React, { Component, useState } from "react";
import { connect } from "react-redux";
import { bool, func } from "prop-types";
import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { actions as actionSoftToken } from "reducers/softToken";
import { selectors as onboardingSelectors, actions as onboardingActions } from "reducers/onboarding";

import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { Mixpanel } from "util/clickstreaming";
import Image from "pages/_components/Image";
import CustomText from "pages/_components/CustomText/CustomText";
import { Field, Formik, Form } from "formik";
import * as Yup from "yup";
import Checkbox from "pages/_components/Checkbox";
import { push } from "connected-react-router";

import { getValidationSchemaTermsAndConditions } from "../../../util/onboarding";

const FORM_ID = "login.step7";
const checkboxContainerStyle = {
    display: "flex",
    flexDirection: "row",
    verticalAlign: "middle",
};

const checkboxLabelStyle = {
    paddingLeft: "0%",
    paddingTop: "0%",
    textAlign: "justify",
    textJustify: "interWord",
};

class Step7Content extends Component {
    constructor(props) {
        super(props);
        this.state = {
            acceptTermsAndConditions: false,
            acceptToken: false,
        };
        this.formRef = React.createRef();
    }

    componentDidMount() {
        if (this.formRef.current && this.props.acceptTermsAndConditionsPF) {
            this.formRef.current.setFieldValue("termsConditions", this.props.acceptTermsAndConditionsPF);
            this.setState({ acceptTermsAndConditions: this.props.acceptTermsAndConditionsPF });
        }

        if (this.formRef.current && this.props.acceptTokenTermAndConditions) {
            this.formRef.current.setFieldValue("terms", this.props.acceptTokenTermAndConditions);
            this.setState({ acceptToken: this.props.acceptTokenTermAndConditions });
        }
    }

    formikProps = {
        initialValues: {
            termsConditions: false,
            terms: false,
        },
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema: () => Yup.lazy(() => getValidationSchemaTermsAndConditions()),
        onSubmit: (valuesForm) => {
            const isCheckedToken = valuesForm?.terms;
            if (isCheckedToken) {
                this.props.dispatch(actionSoftToken.registerUserDevice());
            }
          this.acceptTerms();
        },
    };

    onChangeCheckboxTermsAndConditions = () => {
        this.setState({ acceptTermsAndConditions: !this.state.acceptTermsAndConditions });
        this.props.dispatch(onboardingActions.acceptTermsAndConditionsPF(!this.state.acceptTermsAndConditionsPF));

    };

    onChangeCheckboxToken = () => {
        this.setState({ acceptToken: !this.state.acceptToken });
        this.props.dispatch(onboardingActions.acceptTokenTermsAndConditions(!this.state.acceptToken));

    };

    handleOnclickTermsAndConditions = () => {
        this.props.dispatch(push("/onboarding/stepUserFinish/termsAndConditions"));
    };

    handleOnclickTokenTermsAndConditions = () => {
        this.props.dispatch(push("/onboarding/stepUserFinish/tokenTermsAndConditions"));
    };

    acceptTerms = () => {
        Mixpanel.track(FORM_ID, { acceptConditions: true });
        this.props.dispatch(loginActions.loginStep7(true));
    };

    render() {
        const { isDesktop, isMobile } = this.props;

        return (
            <>
                {isDesktop && (
                    <div className="above-the-fold login-desktop-wrapper">
                        <I18n id="terms.condition.pf.body" />
                    </div>
                )}
                {isMobile && (
                    <>
                        <div className="illustration text-center">
                            <Image src="figma/illustrations/onboarding3.svg" className="svg-image logo" />
                        </div>
                        <div className="box box-border-soft">
                            <CustomText text="terms.condition.pf.disclaimer" textType="I18N" />
                        </div>

                        <Formik {...this.formikProps} ref={this.formRef}>
                            {() => (
                                <Form className="above-the-fold" ref={this.formRef}>
                                    <div className="form-actions" style={{ paddingTop: "0" }}>
                                        <div style={checkboxContainerStyle}>
                                            <Field
                                                component={Checkbox}
                                                idForm={FORM_ID}
                                                name="termsConditions"
                                                hideLabel
                                                onChange={() => this.onChangeCheckboxTermsAndConditions()}
                                            />
                                            <Button
                                                style={checkboxLabelStyle}
                                                className="btn-link"
                                                block={false}
                                                onClick={() => this.handleOnclickTermsAndConditions()}>
                                                <CustomText
                                                    text="onboarding.vu.terms.and.conditions.label"
                                                    textType="I18N"
                                                />
                                            </Button>
                                        </div>
                                        <div style={checkboxContainerStyle}>
                                            <Field
                                                component={Checkbox}
                                                idForm={FORM_ID}
                                                name="terms"
                                                hideLabel
                                                onChange={() => this.onChangeCheckboxToken()}
                                            />
                                            <Button
                                                style={checkboxLabelStyle}
                                                className="btn-link"
                                                block={false}
                                                onClick={() => this.handleOnclickTokenTermsAndConditions()}>
                                                <CustomText text="terms.condition.pf.token.btn" textType="I18N" />
                                            </Button>
                                        </div>
                                        <Button
                                            bsStyle="primary"
                                            defaultLabelText="Continuar"
                                            type="submit"
                                            block
                                            disabled={!(this.state.acceptTermsAndConditions && this.state.acceptToken)}
                                        />
                                    </div>
                                </Form>
                            )}
                        </Formik>
                    </>
                )}
            </>
        );
    }
}

Step7Content.propTypes = {
    isDesktop: bool.isRequired,
    isMobile: bool.isRequired,
    isSubmitting: bool,
    onCancel: func.isRequired,
    dispatch: func.isRequired,
    acceptTermsAndConditionsPF: bool.isRequired,
    acceptTokenTermAndConditions: bool.isRequired,
};

Step7Content.defaultProps = {
    isSubmitting: false,
    exchangeToken: "",
};

const mapStateToProps = (state) => ({
    isSubmitting: loginSelectors.getFetching(state),
    acceptTermsAndConditionsPF: onboardingSelectors.getAcceptTermConditionsPF(state),
    acceptTokenTermAndConditions: onboardingSelectors.getAcceptTokenTermConditions(state),
});

export default connect(mapStateToProps)(Step7Content);
